import Component from '../inherited/Component';
import AjaxApi from '../lib/AjaxApi';
import vex from 'vex-js';

export default class AddToCart extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._options = {
      ...{
        redirect: null,
        addedText: null,
        waitFor: 5000,
        openSideCart: true
      },
      ...this._options
    };
    this._variantIdElem = this._elem.querySelector('[name="id"]');
    this._sellingPlanIdElems = this._elem.querySelectorAll('[name="selling_plan"]');

    this._quantityElem = this._elem.querySelector('[name="quantity"]');
    this._submitElems =
      this._elem.nodeName === 'FORM'
        ? this._elem.querySelectorAll('[type="submit"]')
        : [this._elem];
    this._propertyElems = this._elem.querySelectorAll('[name^="properties"]');

    this._extraProductsInput = this._elem.querySelector('[data-extra-products]');

    this._globalExtraProducts = document.querySelector('[data-extra-atc-products]')
      ? JSON.parse(document.querySelector('[data-extra-atc-products]').innerHTML)
      : [];

    this._originalHTMLs = [];

    this._dawnCart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  mount() {
    this._addListeners();
  }

  _getProperties() {
    this._propertyElems = this._elem.querySelectorAll('[name^="properties"]');
    let properties = {};
    let propElems = Array.from(this._propertyElems).filter(
      (elem) => !elem.hasAttribute('disabled') && elem.value.length > 0
    );
    for (let elem of propElems) {
      properties[elem.getAttribute('name').match(/^properties\[(.+)\]$/)[1]] = elem.value;
    }

    if (propElems.length === 0 && this._elem.dataset.properties) {
      properties = JSON.parse(this._elem.dataset.properties);
    }

    return properties;
  }

  _addListeners() {
    let event = null;
    if (this._elem.nodeName === 'FORM') {
      event = 'submit';
    } else {
      event = 'click';
    }
    this._elem.addEventListener(event, async (e) => {
      e.preventDefault();

      for (let [index, elem] of this._submitElems.entries()) {
        elem.classList.add('ffc--adding-to-cart');
      }

      if (this._options.addedText) {
        for (let elem of this._submitElems) {
          elem.style.minWidth = `${elem.getBoundingClientRect().width}px`;
        }
      }

      let variantId = this._variantIdElem
        ? this._variantIdElem.value
        : this._elem.dataset.variantId;
      let quantity = this._quantityElem
        ? Number(this._quantityElem.value)
        : Number(this._elem.dataset.quantity);
      let selling_plan = this._elem.dataset.sellingPlan || '';

      if (this._sellingPlanIdElems) {
        for (let elem of this._sellingPlanIdElems) {
          if (elem.checked) {
            selling_plan = elem.value;
          }
        }
      }

      let properties = this._getProperties();

      let items = [
        {
          id: variantId,
          quantity: quantity,
          properties: properties,
          selling_plan: selling_plan
        }
      ];

      // Add extra products to every atc (if quantity is less)
      if (this._globalExtraProducts.length) {
        let cart = await AjaxApi.getCart();
        let globalProductsToAdd = this._globalExtraProducts
          .filter((product) => {
            let item = cart.items.find((item) => `${item.variant_id}` === `${product.id}`);
            if (item && item.quantity >= product.quantity) {
              return false;
            }
            return true;
          })
          .map((product) => {
            let item = cart.items.find((item) => `${item.variant_id}` === `${product.id}`);
            if (item && item.quantity < product.quantity) {
              product.quantity -= item.quantity;
            }
            return product;
          });

        items = [...globalProductsToAdd, ...items];
      }

      if (this._extraProductsInput && this._extraProductsInput.value) {
        let extraProducts = JSON.parse(this._extraProductsInput.value);

        for (let prod of extraProducts) {
          items.push({
            id: prod.id,
            quantity: Number(prod.quantity || 1),
            properties: prod.properties || {},
            selling_plan: prod.selling_plan
          });
        }
      }

      try {
        let data = await AjaxApi.addToCart(
          {
            items: items,
            sections: this._dawnCart
              ? this._dawnCart.getSectionsToRender().map((section) => section.id)
              : [],
            sections_url: window.location.pathname
          },
          this._ctx.getState()
        );

        console.log(data);

        if (this._dawnCart) {
          data.key = data.items[0].key;
          this._dawnCart.renderContents(data);
        }

        for (let item of data.items) {
          let matching = items.find((it) => `${it.id}` === `${item.variant_id}`);
          this._ctx.emit('cart-atc', null, {
            item: item,
            quantity: matching.quantity,
            properties: matching.properties
          });
        }

        if(window.SLIDECART_OPEN) {
          window.SLIDECART_UPDATE()
          window.SLIDECART_OPEN()
        }

        this._ctx.emit('cart-item-added');

        if (this._options.openSideCart) {
          this._ctx.emit('show-side-cart');
        }

        if (!this._options.redirect) {
          for (let elem of this._submitElems) {
            elem.classList.remove('ffc--adding-to-cart');
            elem.classList.add('ffc--added-to-cart');
          }

          if (this._options.addedText) {
            for (let elem of this._submitElems) {
              elem.innerHTML = this._options.addedText;
            }
          }

          setTimeout(() => {
            for (let [index, elem] of this._submitElems.entries()) {
              elem.classList.remove('ffc--added-to-cart');
            }
          }, this._options.waitFor);
        }

        if (this._options.redirect) {
          window.location = this._options.redirect;
        }
      } catch (e) {
        console.error('ERROR');
        console.error(e);
        console.error(e.response.data);

        console.error(e);
        vex.dialog.alert(e.response.data.description);

        for (let [index, elem] of this._submitElems.entries()) {
          elem.classList.remove('ffc--adding-to-cart');
          elem.classList.remove('ffc--added-to-cart');
        }
      }
    });
  }
}
